// @ts-strict-ignore
import React from 'react';
import {
  Box, Text, useSnackBar,
} from '@usealloy/component-library';
import type { FieldValues } from 'react-hook-form';
import {
  useForm,
  FormProvider,
} from 'react-hook-form';

import { ajaxFetch } from '~/helpers/api';
import log from '~/helpers/logging';
import { routes } from '~/helpers/routes';
import FormContainer from '../FormContainer';
import { InputFieldType } from '../FormContainer/types';
import { StyledLink } from '../AuthContainerView/styles';
import { useNavigate, NavLink } from 'react-router-dom';

interface IFormFields {
  email: string;
}

const formDefaultValues = {
  email: '',
};

const ForgotPasswordView = () => {
  const navigate = useNavigate();
  const addSnackBar = useSnackBar();

  const methods = useForm<IFormFields>({ defaultValues: formDefaultValues, mode: 'all' });

  const fields = [
    {
      type: InputFieldType.EMAIL,
      label: 'Email',
      name: 'email',
      error: 'Email required',
      required: true,
    },
  ];

  // @todo: After successful submit, show message "A password request has been sent to the specified email if valid" in Signin View
  const onForgotPassSubmit = async (formData: FieldValues) => {
    const genericErrorMessage = 'Something went wrong while submitting the forgot password request';
    try {
      const response = await ajaxFetch(routes.authentication.resetPassword.basic,
        {
          method: 'POST',
          body: JSON.stringify({ ...formData, next_url: '/' }),
          camelCase: true,
          enhancedErrorResponse: true,
        },
      );

      if (response?.result === 'success') {
        navigate(routes.v3.dashboard.authentication.login, {
          state: {
            message: {
              text: 'A password reset link has been sent to the specified email if valid.',
              type: 'success',
            },
          },
        });
      }
    } catch (err) {
      addSnackBar({
        title: err.message || genericErrorMessage,
        type: 'danger',
      });
      log('error', `GET ${routes.authentication.resetPassword.basic} exception`, {}, err);
    }
  };

  return (
    <Box direction="column" gap={4} alignItems="stretch" style={{ width: '440px' }}>
      <Text as="h1" size={7} style={{ textAlign: 'center' }}>Forgot Password</Text>
      <FormProvider {...methods}>
        <FormContainer
          fields={fields}
          onSubmit={onForgotPassSubmit}
          onSubmitActionText="Reset"
        />
      </FormProvider>

      <NavLink to={routes.v3.dashboard.authentication.login}>
        <StyledLink forwardedAs="span">
          Return to sign in
        </StyledLink>
      </NavLink>
    </Box>
  );
};

export default ForgotPasswordView;
